import React from 'react';
import { Button } from './ui/button';
import type { Form } from '../interfaces/form.interface';

interface FormRetryErrorProps {
  configuration: Form;
  message: string;
  ctaText?: string;
  onRetry: () => void;
  retryButtonRef?: React.Ref<HTMLButtonElement>;
}

export const FormRetryError: React.FC<FormRetryErrorProps> = ({
  configuration,
  message,
  ctaText = 'Reintentar',
  onRetry,
  retryButtonRef,
}) => {
  return (
    <div className="flex justify-center items-center w-full min-h-[60vh]">
      <div
        className="w-full max-w-[560px] rounded-xl shadow px-6 py-8 text-center bg-white border"
        role="alert"
        aria-live="assertive"
      >
        <div
          className="h-1 w-full rounded-full mb-6"
          style={{ background: (configuration.theme?.buttons?.style?.background as string) || '#ECA92B' }}
        />
        <div className="text-5xl mb-4" style={{ color: (configuration.theme?.buttons?.style?.background as string) || '#ECA92B' }}>⚠️</div>
        <h2 className="text-2xl font-bold mb-2" style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
          No pudimos enviar tu inscripción
        </h2>
        <p className="mb-6" style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
          {message}
        </p>
        <div className="flex justify-center py-2">
          <Button
            ref={retryButtonRef}
            type="button"
            className="cursor-pointer h-11 px-12 rounded-[14px] text-sm"
            style={{
              background: configuration.theme?.buttons?.style?.background || '#1890ff',
              borderColor: configuration.theme?.buttons?.style?.background || '#1890ff',
              color: configuration.theme?.buttons?.style?.color || '#ffffff',
            }}
            onClick={onRetry}
          >
            {ctaText}
          </Button>
        </div>
        <p className="mt-3 text-sm opacity-80" style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
          Volverás al formulario con tus respuestas conservadas.
        </p>
      </div>
    </div>
  );
};


